import { image } from '../../../../utils/data/baseUrl';
import React from 'react';

export default function TaskItemSegmentImage({ quest }) {
  const { requiredSegment } = quest;

  return (
    requiredSegment && (
      <div className={'task__item-teens'}>
        <img src={image('tasks/teens.png')} />
      </div>
    )
  );
}
